/* eslint-disable camelcase */
import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'

const aesKey = Cookies.get('aes_key')

function wm_sign (body) {
  const payload = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(body)))
  const signature = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(payload, process.env.REACT_APP_SIGN_KEY))
  const sign = payload + '.' + signature
  return sign
}

function wm_aes (input) {
  try {
    const keyHash = CryptoJS.SHA384(process.env.REACT_APP_AES_KEY)
    const key = CryptoJS.enc.Hex.parse(keyHash.toString().substring(0, 64))
    const iv = CryptoJS.enc.Hex.parse(keyHash.toString().substring(64, 96))
    const encrypted = CryptoJS.AES.encrypt(input, key, { iv: iv })
    return encrypted.toString()
  } catch (error) {
    console.log(error)
  }
}

function randomString (length) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength))
  }
  return result
}

function wm_aes_for_web (input) {
  const keyHash = CryptoJS.SHA384(aesKey)
  const key = CryptoJS.enc.Hex.parse(keyHash.toString().substring(0, 64))
  const iv = CryptoJS.enc.Hex.parse(keyHash.toString().substring(64, 96))
  const encrypted = CryptoJS.AES.encrypt(input, key, { iv: iv })
  return encrypted.toString()
}

export { wm_sign as wmSign, wm_aes as wmAes, randomString, wm_aes_for_web }
